import type { PromotionWithTargets } from '../domain/promotionTypes';
import {
  formatPromotionBenefit,
  PROMOTION_APPLY_MODE_LABELS,
  PROMOTION_KIND_LABELS,
  PROMOTION_SCOPE_LABELS,
  promotionStatusLabel,
} from '../application/promotionPresentation';
import { escapeCsvCell } from '../../shared/csv-core/infra/buildCsv';

export function buildPromotionsListCsv(promos: PromotionWithTargets[]): string {
  const header = [
    'id',
    'nombre',
    'descripcion',
    'tipo',
    'alcance',
    'beneficio',
    'modo',
    'estado',
    'codigo',
    'prioridad',
    'apilable',
    'fecha_inicio',
    'fecha_fin',
    'activa',
    'targets',
    'condiciones',
  ];

  const lines = promos.map((p) => {
    const cells = [
      p.id,
      p.name,
      p.description ?? '',
      PROMOTION_KIND_LABELS[p.kind],
      PROMOTION_SCOPE_LABELS[p.scope],
      formatPromotionBenefit(p),
      PROMOTION_APPLY_MODE_LABELS[p.applyMode],
      promotionStatusLabel(p),
      p.promoCode ?? '',
      String(p.priority),
      p.stackable ? 'si' : 'no',
      p.startsAt ?? '',
      p.endsAt ?? '',
      p.isActive ? 'si' : 'no',
      p.targets.map((t) => `${t.targetType}:${t.targetId}`).join('|'),
      p.conditions ? JSON.stringify(p.conditions) : '',
    ].map((cell) => escapeCsvCell(String(cell)));
    return cells.join(',');
  });

  return [header.join(','), ...lines].join('\n');
}
